const timeseries = [
  { label: 'graph_options.timeseries.weekly', value: 'weekly' },
  { label: 'graph_options.timeseries.monthly', value: 'monthly' },
  { label: 'graph_options.timeseries.yearly', value: 'yearly' },
];

export default timeseries;
